export const DEFAULT_DEBOUNCE_PERIOD = 500
export const DEFAULT_EVENT_LIMIT = 20
export const EVENT_PUBLISHER_DEBOUNCE_PERIOD = 50
